export default __webpack_public_path__ + "static/media/celebrate.bca9dcddf59749e978bf552bc3d24a61.svg";